export default {"badge":"Pi17k","ai":"jQzmp"};